export function IconEmail() {
  return (
    <svg width="32" height="32" viewBox="0 0 40 40" fill="none">
      <rect width="40" height="40" rx="6" fill="#FDEBEB" />
      <path
        d="M11.6045 12.4609H27.6045C28.7045 12.4609 29.6045 13.3609 29.6045 14.4609V26.4609C29.6045 27.5609 28.7045 28.4609 27.6045 28.4609H11.6045C10.5045 28.4609 9.60449 27.5609 9.60449 26.4609V14.4609C9.60449 13.3609 10.5045 12.4609 11.6045 12.4609Z"
        stroke="url(#paint0_linear_751_8966)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.6045 14.4609L19.6045 21.4609L9.60449 14.4609"
        stroke="url(#paint1_linear_751_8966)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_751_8966"
          x1="19.6045"
          y1="12.4609"
          x2="19.6045"
          y2="28.4609"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#38D3C1" />
          <stop offset="1" stopColor="#81C149" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_751_8966"
          x1="19.6045"
          y1="14.4609"
          x2="19.6045"
          y2="21.4609"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#38D3C1" />
          <stop offset="1" stopColor="#81C149" />
        </linearGradient>
      </defs>
    </svg>
  );
}
